// extracted by mini-css-extract-plugin
module.exports = {"header":"EcgMeta_header__KlJ-f","meta":"EcgMeta_meta__1lCYB"};